<template>
  <div class="calendar">
    <Banner />
    <div class="box-1">
      <Calendar />
      <div style="height: 40px"></div>
    </div>
    <div class="box-2 container">
      <div style="height:100px"></div>
      <div class="title">文化日历</div>
      <div class="intro">记录每一天的文化活动</div>
      <div class="month flex">
        <div v-for="v in 12" :key="'a' +  v"  :class="`item flex-item ${month == v ? 'on' : ''}`" @click="handleMonth(v)">{{v}}月</div>
      </div>
      <div style="height: 30px"></div>
      <div class="days flex">
        <div v-for="v in monthDays[month - 1]" :key="v" :class="`day ${v == day ? 'on' : ''} ${isArr(v, redArr) ? 'yes' : ''}`" @click="handleDay(v)">{{formatNumber(v)}}</div>
      </div>
      <div style="height: 50px"></div>
    </div>
    <div class="box-3">
      <div class="container">
        <div class="article-items flex">
          <List :listData="listData" />
        </div>
        <div class="tip-box flex">
          <el-divider v-show="loading && !isOver"><el-button :loading="true">加载中</el-button></el-divider>
          <el-divider v-show="!loading && !isOver"><el-button size="small" @click="getList()">加载更多</el-button></el-divider>
          <el-divider v-show="!loading && isOver">已全部加载</el-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/5101/index/Banner'
import Calendar from '@/components/5101/Calendar'
import List from "@/components/common/List.vue"
import { reactive, toRefs } from "vue"
import { formatTime, formatNumber, isArr } from "@/tools"
import { api } from "@/api"
export default {
  name: "calendar-page",
  components: { Banner, Calendar, List },
  setup() {
    let initData = reactive({
      
      monthDays: [31,28,31,30,31,30,31,31,30,31,30,31],

      year: "",
      month: "",
      day: "",

      redArr: [],

      loading: false,
      isOver: false,
      page: 1,
      listData: [],
    })
    init()
    function init() {
      let today = +new Date()
      initData.year = formatTime(today, "YYYY")
      initData.month = formatTime(today, "M")
      initData.day = formatTime(today, "DD")
      initData.monthDays[1] = (initData.year % 400 == 0 || (initData.year % 4 == 0 && initData.year % 100 != 0 )) ? 29 : 28;
      getCalendarHasSerfun()
      getList()
    }
    function handleMonth(month) {
      initData.month = month
      getCalendarHasSerfun()
      reset()
    }
    function handleDay(day) {
      initData.day = day
      reset()
    }
    
    function getCalendarHasSerfun() {
      let data = {
        
        inappcode: "5101",
        startime: `${initData.year}${formatNumber(initData.month)}01`,
        endtime: `${initData.year}${formatNumber(initData.month)}${initData.monthDays[initData.month - 1]}`,
      }
      api('get', "getCalendarHasSerfun", data)
        .then(res => {
          if(res.code === 1200) {
            res.data.map(item => {
              if(item.substr(0,1) == "0") {
                initData.redArr.push(item.substr(1,1))
              } else {
                initData.redArr.push(item)
              }
            })
          }
        })
    }
    function reset() {
      initData.isOver = false
      initData.loading = false
      initData.page = 1
      initData.listData = []
      getList()
    }
    function getList() {
      let data = {
        pageNum: initData.page,
        pageSize: 12,
        time: `${initData.year}${formatNumber(initData.month)}${initData.day}`,
        appcode: ""
      };
      initData.loading = true
      api("get", "getCalendarByTime", data)
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            if(res.data) { // 数据存  处理后台返回 null
              if(initData.page == 1) { // 处理掉loading数据
                initData.listData = res.data
              } else {
                initData.listData = [ ...initData.listData, ...res.data]
              }
              // 加载完成
              if(res.data.length < 12) {
                initData.isOver = true
              } else {
                initData.page += 1
              }
            } else {
              initData.isOver = true
            }
          } else {
            initData.isOver = true
          }
        })
        .catch(err => {
          initData.isOver = true
          initData.loading = false

        })
    }
    return {
      ...toRefs(initData),
      handleMonth,
      handleDay,
      formatNumber,
      isArr
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'sy';
  src: url('~@/assets/ttf/font_1.ttf');
}
.box-1 {
  background-color: #F6F6F6;
  padding-top: 120px;
  :deep(.rl-box .week-box .week) {
    color: #8C96A1;
  }
  :deep(.rl-box .week-box .week.on) {
    color: #1A2E43;
    &::after {
      background-image: url('~@/assets/5101/icon_16.png')
    }
  }
  :deep(.rl-box .items .item) {
    background-color: #fff;
    .title {
      color: #1A2E43;
    }
    .time {
      color: #6B7F96;
    }
    .txt {
      color: #103358;
    }
    &:hover {
      background-color: #103358;
      .title {
        color: white;
      }
      .txt,.time {
        color: white;
        opacity: .7;
      }
    }
  }
}
.box-2 {
  text-align: center;
  .title {
    font-size: 30px;
  }
  .intro {
    color: #9EA1A4;
    margin-top: 10px;
  }
  .month {
    justify-content: center;
    margin-top: 50px;
    position: relative;
    &::after {
      content: '';
      height: 2px;
      background-color: #D2D2D2;
      position: absolute;
      
      left: 0;
      right: 0;
      bottom: 0px;
      
    }
    .item {
      padding-bottom: 20px;
      font-size: 20px;
      font-family: 'sy';
      cursor: pointer;
      
      &:hover {
        color: #10BB58;
      }
    }
    .item.on {
      font-size: 24px;
      font-weight: bold;
      color: #10BB58;
      background-image: url("~@/assets/5101/icon_3.png");
      background-size: auto auto;
      background-repeat: no-repeat;
      background-position: center bottom;
      position: relative;
      z-index: 2;
    }
  }
  .days {
    flex-wrap: wrap;
    justify-content: space-between;
    .day {
      width: 70px;
      height: 38px;
      margin: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9EA1A4;
      font-family: 'sy';
      background-image: url('~@/assets/5101/icon_17.png');
      background-size: 100%;
      line-height: 1;
      cursor: pointer;
      position: relative;
      &:hover {
        color: #10BB58;
      }
    }
    .day.on {
      background-image: url('~@/assets/5101/icon_18.png');
      color: #fff;
    }
    .day.yes {
      &::after {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #0F1B29;
        position: absolute;
        right: 11px;
        top: 7px;
      }
    }
    .day.yes.on {
      &::after {
        background-color: #fff;
      }
    }
  }
}
.box-3 {
  background-color: #F6F6F6;
  .container {
    width: 1220px;
    .article-items {
      flex-wrap: wrap;
      :deep(.article-box) {
        margin: 40px 10px;
      }
  
    }
    .tip-box {
      width: 1200px;
      height: 100px;
      margin: 0 auto;
      align-items: center;
      justify-content: center;
      
    }
    :deep(.el-divider__text) {
      background-color: #F6F6F6;
      color: #585858;
    }
  }
}
</style>